import { useEffect, useState } from "react";

import { FrontendConfig } from "src/utility/announcements";

/**
 * Hook to fetch the Vercel Edge Config frontend configuration.
 * This contains various frontend settings including announcements.
 *
 * @returns The frontend config object, or undefined if not available
 */
export function useVercelFrontendConfig(): FrontendConfig | undefined {
  const [config, setConfig] = useState<FrontendConfig | undefined>(undefined);

  useEffect(() => {
    async function fetchConfig() {
      try {
        const response = await fetch("/api/frontend-config");
        if (response.ok) {
          const data = await response.json();
          setConfig(data.frontendConfig || undefined);
        }
      } catch (error) {
        // Silently fail, config is optional
      }
    }

    fetchConfig();
  }, []);

  return config;
}
